module.exports = __webpack_public_path__ + "img/indexs_icon2.a55ee982.png";